/** Curated Unsplash imagery — warm, healthcare-focused (used across patient portal). */
export const PATIENT_PORTAL_IMAGES = {
  home: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?auto=format&fit=crop&w=1400&q=80',
  /** Happy family — bundled under /public (loyalty tile; external URL was 404) */
  loyalty: '/patient-portal/loyalty-family.jpg',
  records: 'https://images.unsplash.com/photo-1579154204601-01588f351e67?auto=format&fit=crop&w=1400&q=80',
  booking: 'https://images.unsplash.com/photo-1629909613654-28e377c37b09?auto=format&fit=crop&w=1400&q=80',
  wallet: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?auto=format&fit=crop&w=1400&q=80',
  family: 'https://images.unsplash.com/photo-1511895426328-dc8714191300?auto=format&fit=crop&w=1400&q=80',
  referrals: 'https://images.unsplash.com/photo-1529156069898-49953e39b3ac?auto=format&fit=crop&w=1400&q=80',
  challenges: 'https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?auto=format&fit=crop&w=1400&q=80',
  notifications: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=1400&q=80',
  login: 'https://images.unsplash.com/photo-1631217868264-e5b7bb5e8b7e?auto=format&fit=crop&w=1400&q=80',
} as const;

export type PatientPortalImageKey = keyof typeof PATIENT_PORTAL_IMAGES;
